// Plyr control color override
var plyrStyle = document.createElement("style");
plyrStyle.textContent = "--plyr-color-main: #f33f32;" +
  ".plyr--full-ui input[type=range]{color:#f33f32}" +
  ".plyr__control--overlaid{background:#f33f32}" +
  ".plyr__control--overlaid:hover{background:#d63529}" +
  ".plyr__menu__container [role=menuitemradio][aria-checked=true]::before{background:#f33f32}" +
  "[id^='vertical_video-'] .plyr__control--overlaid{display:none!important}" +
  "[id^='vertical_video-'] .plyr__controls{display:none!important}";
document.head.appendChild(plyrStyle);

document.addEventListener("DOMContentLoaded", function () {
    console.log("DOMContentLoaded");
  const OFFSET = 82 + 16; // navbar height + 16px breathing room
  const ACTIVE_COLOR = "#8D4CDD";
  const tocLinks = document.querySelectorAll(".toc-link");
  const sections = [];

  // Build sections array from TOC link hrefs
  tocLinks.forEach(function (link) {
    const href = link.getAttribute("href");
    if (!href) return;
    const id = href.replace("#", "");
    const target = document.getElementById(id);
    if (target) {
      sections.push({ id: id, el: target, link: link });
    }
  });

  // Store each link's original color
  tocLinks.forEach(function (link) {
    link.dataset.originalColor = getComputedStyle(link).color;
  });

  // Disable Webflow's native smooth scroll on TOC links
  tocLinks.forEach(function (link) {
    link.removeAttribute("data-wf-id");
    link.removeAttribute("data-wf-element");
  });

  // Disable CSS scroll-behavior so we control it entirely
  document.documentElement.style.scrollBehavior = "auto";

  // Smooth scroll on click with offset
  tocLinks.forEach(function (link) {
    link.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();

      // Remove hash from URL to prevent browser jump
      history.pushState(null, null, " ");

      const id = this.getAttribute("href").replace("#", "");
      const target = document.getElementById(id);
      if (!target) return;

      // Collapse mobile TOC on click below 991px by triggering Webflow's own interaction
      if (window.innerWidth < 991) {
        var mToc = document.getElementById("m-toc");
        if (mToc && mToc.offsetHeight > 60) {
          mToc.click();
        }
      }

      const top = target.getBoundingClientRect().top + window.pageYOffset - OFFSET;
      window.scrollTo({ top: top, behavior: "smooth" });
    }, true); // capture phase to fire before Webflow's handler
  });

  // Close #m-toc when clicking anywhere else on the page
  document.addEventListener("click", function (e) {
    if (window.innerWidth >= 991) return;
    var mToc = document.getElementById("m-toc");
    if (!mToc) return;
    if (mToc.contains(e.target)) return;
    if (mToc.offsetHeight > 60) {
      mToc.click();
    }
  });

  var lastActive = null;

  // Highlight active link on scroll
  function setActiveLink() {
    var current = null;
    var viewportBottom = window.innerHeight;

    for (var i = 0; i < sections.length; i++) {
      var rect = sections[i].el.getBoundingClientRect();
      // Becomes active once 30px into viewport from bottom, stays active after scrolling past
      if (rect.top <= viewportBottom - 30) {
        current = sections[i];
      }
    }

    // Keep last highlighted if nothing new qualifies
    if (current) {
      lastActive = current;
    } else {
      current = lastActive;
    }

    tocLinks.forEach(function (link) {
      link.style.color = link.dataset.originalColor;
      link.style.fontWeight = "";
    });

    if (current) {
      current.link.style.color = ACTIVE_COLOR;
      current.link.style.fontWeight = "bold";
    }
  }

  // Throttle scroll events
  var ticking = false;
  window.addEventListener("scroll", function () {
    if (!ticking) {
      window.requestAnimationFrame(function () {
        setActiveLink();
        ticking = false;
      });
      ticking = true;
    }
  });

  // Set initial state
  setActiveLink();

  // ── Plyr Video Player (CLS-safe) ──
  var videoBlock = document.querySelector(".plyr_video_block");
  if (videoBlock) {
    // Reserve space to prevent layout shift (16:9)
    videoBlock.style.position = "relative";
    videoBlock.style.paddingBottom = "56.25%";
    videoBlock.style.height = "0";
    videoBlock.style.overflow = "hidden";
    videoBlock.style.background = "#000";

    // Create Vimeo embed
    var wrapper = document.createElement("div");
    wrapper.style.position = "absolute";
    wrapper.style.top = "0";
    wrapper.style.left = "0";
    wrapper.style.width = "100%";
    wrapper.style.height = "100%";
    wrapper.setAttribute("data-plyr-provider", "vimeo");
    wrapper.setAttribute("data-plyr-embed-id", "1179547652");
    videoBlock.appendChild(wrapper);

    // Init Plyr
    var player = new Plyr(wrapper, {
      resetOnEnd: true
    });

    // Custom frosted glass play overlay
    var overlay = document.createElement("div");
    overlay.style.cssText = "position:absolute;top:0;left:0;right:0;bottom:0;display:flex;align-items:center;justify-content:center;z-index:10;cursor:pointer;";

    var pill = document.createElement("div");
    pill.style.cssText = "display:flex;align-items:center;gap:12px;padding:14px 32px;border-radius:999px;background:rgba(0,0,0,0.39);backdrop-filter:blur(16px);-webkit-backdrop-filter:blur(16px);border:none;color:#fff;font-size:18px;font-weight:500;transition:background 0.2s;";

    // Play triangle icon
    var icon = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    icon.setAttribute("viewBox", "0 0 24 24");
    icon.setAttribute("fill", "white");
    icon.setAttribute("width", "22");
    icon.setAttribute("height", "22");
    var path = document.createElementNS("http://www.w3.org/2000/svg", "path");
    path.setAttribute("d", "M8 5v14l11-7z");
    icon.appendChild(path);

    var label = document.createElement("span");
    label.textContent = "Play video";

    pill.appendChild(icon);
    pill.appendChild(label);
    overlay.appendChild(pill);

    // Append overlay to the Webflow wrapper which has real dimensions
    var videoWrapper = document.querySelector(".video_wrapper");
    if (videoWrapper) {
      videoWrapper.style.position = "relative";
      videoWrapper.appendChild(overlay);
    }

    // Magnetic follow effect on pill
    pill.style.transition = "background 0.2s";
    pill.style.pointerEvents = "none";

    overlay.addEventListener("mousemove", function (e) {
      var rect = overlay.getBoundingClientRect();
      var x = e.clientX - rect.left - rect.width / 2;
      var y = e.clientY - rect.top - rect.height / 2;
      gsap.to(pill, {
        x: x * 0.3,
        y: y * 0.3,
        duration: 0.4,
        ease: "power2.out"
      });
      pill.style.background = "rgba(0,0,0,0.5)";
    });

    overlay.addEventListener("mouseleave", function () {
      gsap.to(pill, {
        x: 0,
        y: 0,
        duration: 0.6,
        ease: "elastic.out(1, 0.5)"
      });
      pill.style.background = "rgba(0,0,0,0.39)";
    });

    // Click to play and hide overlay
    overlay.addEventListener("click", function () {
      player.play();
      overlay.style.display = "none";
    });

    // Show overlay again when video ends
    player.on("ended", function () {
      overlay.style.display = "flex";
    });

    // Hide Plyr's default big play button
    player.on("ready", function () {
      videoBlock.style.paddingBottom = "";
      videoBlock.style.height = "";
      videoBlock.style.position = "";
      videoBlock.style.overflow = "";

      var plyrBtn = videoBlock.querySelector(".plyr__control--overlaid");
      if (plyrBtn) plyrBtn.style.display = "none";
    });
  }

  // ── Vertical Video Players ──
  var verticalVideos = [
    { containerId: "vertical_video-1", vimeoId: "1179493915" },
    { containerId: "vertical_video-2", vimeoId: "1179494833" },
    { containerId: "vertical_video-3", vimeoId: "1179489548" }
  ];

  verticalVideos.forEach(function (vid) {
    var container = document.getElementById(vid.containerId);
    if (!container) return;

    container.style.position = "relative";
    container.style.overflow = "hidden";
    container.style.background = "#000";

    // Create Vimeo embed
    var vWrapper = document.createElement("div");
    vWrapper.style.cssText = "position:absolute;top:0;left:0;width:100%;height:100%;";
    vWrapper.setAttribute("data-plyr-provider", "vimeo");
    vWrapper.setAttribute("data-plyr-embed-id", vid.vimeoId);
    container.appendChild(vWrapper);

    var vPlayer = new Plyr(vWrapper, {
      resetOnEnd: true,
      controls: []
    });

    // Play button overlay — circle with play icon only
    var vOverlay = document.createElement("div");
    vOverlay.style.cssText = "position:absolute;top:0;left:0;right:0;bottom:0;display:flex;align-items:center;justify-content:center;z-index:10;cursor:pointer;";

    var circle = document.createElement("div");
    circle.style.cssText = "display:flex;align-items:center;justify-content:center;width:60px;height:60px;border-radius:50%;background:rgba(0,0,0,0.39);backdrop-filter:blur(16px);-webkit-backdrop-filter:blur(16px);transition:background 0.2s;";

    var vIcon = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    vIcon.setAttribute("viewBox", "0 0 24 24");
    vIcon.setAttribute("fill", "white");
    vIcon.setAttribute("width", "22");
    vIcon.setAttribute("height", "22");
    var vPath = document.createElementNS("http://www.w3.org/2000/svg", "path");
    vPath.setAttribute("d", "M8 5v14l11-7z");
    vIcon.appendChild(vPath);

    circle.appendChild(vIcon);
    vOverlay.appendChild(circle);
    container.appendChild(vOverlay);

    // Hover
    vOverlay.addEventListener("mouseenter", function () {
      circle.style.background = "rgba(0,0,0,0.5)";
    });
    vOverlay.addEventListener("mouseleave", function () {
      circle.style.background = "rgba(0,0,0,0.39)";
    });

    // Click to play
    vOverlay.addEventListener("click", function () {
      vPlayer.play();
      vOverlay.style.display = "none";
    });

    // Show overlay on end
    vPlayer.on("ended", function () {
      vOverlay.style.display = "flex";
    });

    // Hide Plyr's default play button
    vPlayer.on("ready", function () {
      var btn = container.querySelector(".plyr__control--overlaid");
      if (btn) btn.style.display = "none";
    });
  });

  // ── Hero staggered fade-up animation ──
  gsap.set([".aw_logo_top", ".cross_icon", ".pm_logo_top"], {
    opacity: 0,
    y: 40
  });
  var heroTl = gsap.timeline({ delay: 0.3 });

  heroTl.to([".aw_logo_top", ".cross_icon", ".pm_logo_top"], {
    opacity: 1,
    y: 0,
    duration: 1.2,
    ease: "power2.out",
    stagger: 0.35
  });

  // ── Hero text word-by-word fade-up ──
  var heroTxt = document.getElementById("hero_txt");
  if (heroTxt) {
    var words = heroTxt.textContent.trim().split(/\s+/);
    heroTxt.innerHTML = words.map(function (word) {
      return '<span style="display:inline-block;opacity:0;transform:translateY(20px)">' + word + '</span>';
    }).join(' ');

    var wordSpans = heroTxt.querySelectorAll("span");
    heroTl.to(wordSpans, {
      opacity: 1,
      y: 0,
      duration: 0.9,
      ease: "power2.out",
      stagger: 0.12
    }, "-=1.2"); // start when logo animation is roughly midway

    // ── PM pointers fade-up ──
    gsap.set(".pm-pointers-wraper", { opacity: 0, y: 40 });
    heroTl.to(".pm-pointers-wraper", {
      opacity: 1,
      y: 0,
      duration: 1,
      ease: "power2.out"
    }, "-=1.0"); // start early during text animation

    // ── Video wrapper fade-up ──
    gsap.set(".video_wrapper", { opacity: 0, y: 40 });
    heroTl.to(".video_wrapper", {
      opacity: 1,
      y: 0,
      duration: 1,
      ease: "power2.out"
    }, "-=0.5");
  }

  // ── Content section scroll-triggered fade-up (waits for hero) ──
  gsap.registerPlugin(ScrollTrigger);

  gsap.set([".case_study_toc_wrapper", ".case_study_block"], {
    opacity: 0,
    y: 40
  });

  heroTl.eventCallback("onComplete", function () {
    ScrollTrigger.create({
      trigger: "#content_section",
      start: "top 80%",
      once: true,
      onEnter: function () {
        var contentTl = gsap.timeline();
        contentTl.to(".case_study_toc_wrapper", {
          opacity: 1,
          y: 0,
          duration: 1,
          ease: "power2.out"
        }).to(".case_study_block", {
          opacity: 1,
          y: 0,
          duration: 1,
          ease: "power2.out"
        }, "-=0.5");
      }
    });
  });

  // ── Number count-up animation ──
  var numberTargets = [
    { value: 7.5, suffix: "hrs", decimals: 1 },
    { value: 2, suffix: "hrs", decimals: 0 },
    { value: 2, suffix: "hrs", decimals: 0 },
    { value: 40, suffix: "mins", decimals: 0 }
  ];

  var numberEls = document.querySelectorAll("[id='anime_number']");
  numberEls.forEach(function (el, i) {
    if (!numberTargets[i]) return;
    var target = numberTargets[i];
    var counter = { val: 0 };

    el.textContent = "0" + target.suffix;

    ScrollTrigger.create({
      trigger: el,
      start: "top 90%",
      once: true,
      onEnter: function () {
        gsap.to(counter, {
          val: target.value,
          duration: 1.5,
          ease: "power2.out",
          onUpdate: function () {
            el.textContent = counter.val.toFixed(target.decimals) + target.suffix;
          }
        });
      }
    });
  });
});
